import { AuthEntrancePage } from "./AuthEntrancePage.page";

export function SignUpPage() {
  return <AuthEntrancePage page="signUp"/>
}